module.exports = __webpack_public_path__ + "images/emoji/mouse2.53df268171a57491caed.png";